/// <reference path="../../../../typings/index.d.ts" />

// TODO: Split to separate components!!!11!111
module Meevo.Plugins.EftControlPanel {
    'use strict';

    import NounEnum = Meevo.Model.NounEnum;
    import PaymentMethodEnum = Meevo.Model.PaymentAccountTypeEnum;
    import PhoneTypeEnum = Meevo.Model.PhoneTypeEnum;
    import PaymentIssueEnum = Meevo.Model.ProcessorResponseCodeEnum;
    import TrackingItem = Meevo.Model.TrackingItem;
    import VerbEnum = Meevo.Model.VerbEnum;
    import PaymentPlansHelper = Meevo.Plugins.PaymentPlans.PaymentPlansHelper;

    interface ICriteria {
        itemsPerPage: number,
        criteria: {
            EFTPaymentDateFrom: Date;
            EFTPaymentDateTill: Date;
            EFTStatus: any;
            EFTPaymentMethod: any;
            EFTPaymentIssue: any;
            isPaymentPlanEFT: boolean;
        }
    }

    interface IEftControlPanelController {
        filterCriteria: ICriteria;
        selectedItem: any;
        client?: IClientData;
        currentDate: Date;
        yearBeforeCurrentDate: Date;
        monthBeforeCurrentDate: Date;
        showClientProfile: ($event: any, id: Guid) => void;

        closeContext: () => void;
        criteriaChanged: () => void;
    }

    class EftControlPanelController implements IEftControlPanelController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$locale',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.ClientMembershipDataService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.plugins.eftControlPanel.EFTControlPanelAPI',
            'meevo.plugins.paymentPlans.PaymentPlansHelper',
            "$mdSidenav"
        ];

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        public selectAllEft: boolean = false;
        public isDisabledSelectAll: boolean = false;
        public selectedItem: any | IPaymentPlanEFTResponseItem;
        public currentDate: Date = new Date(new Date().setHours(0, 0, 0, 0));
        public monthBeforeCurrentDate: Date;
        public yearBeforeCurrentDate: Date = new Date(new Date(new Date().getTime() - (365 * 24 * 60 * 60 * 1000)).setHours(0, 0, 0, 0));
        public eftList: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public ppList: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public filterCriteria: ICriteria = {
            itemsPerPage: 25,
            criteria: {
                EFTPaymentDateFrom: this.currentDate,
                EFTPaymentDateTill: this.currentDate,
                EFTStatus: null,
                EFTPaymentMethod: null,
                EFTPaymentIssue: null,
                isPaymentPlanEFT: false,
            },
        };
        public client?: IClientData;
        public efts = {
            count: 0,
            totalCost: 0
        };
        public eftsSelected = {
            count: 0,
            totalCost: 0
        };
        public paymentPlanSelectedEFTsTotal = {
            count: 0,
            totalCost: 0
        };
        public selectedTotalCost: string = '0';
        public checkedEfts = [];
        public isDisableEFTPaymentMethod = false;
        public loadedItemsCount = 0;
        public paymentMethodEnum = PaymentMethodEnum;

        public showDatePicker: boolean = false;
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;

        private eftStatusEnumForTable: any;

        private _eftStatusEnum = [
            {
                id: EFTStatusEnum.NotBilled,
                label: 'LABEL_NOT_BILLED'
            },
            {
                id: EFTStatusEnum.Paid,
                label: 'LABEL_PAID'
            },
            {
                id: EFTStatusEnum.FreezeFee,
                label: 'LABEL_FROZEN'
            },
            {
                id: EFTStatusEnum.Suspended,
                label: 'LABEL_SUSPENDED'
            },
            {
                id: EFTStatusEnum.Pending,
                label: 'LABEL_PENDING_ACH'
            },
            {
                id: EFTStatusEnum.Error,
                label: 'LABEL_ERROR'
            },
            {
                id: EFTStatusEnum.Waived,
                label: 'LABEL_WAIVED'
            },
            {
                id: EFTStatusEnum.Processing,
                label: 'LABEL_PROCESSING'
            }
        ];
        private _ppEFTStatusEnumList = [
            {
                id: EPaymentPlanBillStatusEnum.NotBilled,
                label: 'LABEL_NOT_BILLED'
            },
            {
                id: EPaymentPlanBillStatusEnum.Paid,
                label: 'LABEL_PAID'
            },
            {
                id: EPaymentPlanBillStatusEnum.PastDue,
                label: 'LABEL_PAST_DUE'
            },
            {
                id: EPaymentPlanBillStatusEnum.Error,
                label: 'LABEL_ERROR'
            },
            {
                id: EPaymentPlanBillStatusEnum.Processing,
                label: 'LABEL_PROCESSING'
            }
        ];
        private _paymentMethodEnum = [
            {
                id: '',
                label: 'LABEL_ALL'
            },
            {
                id: PaymentMethodEnum.ACHChecking,
                label: 'LABEL_ACH'
            },
            {
                id: PaymentMethodEnum.Card,
                label: 'LABEL_CREDIT_CARD'
            }
        ];
        private _paymentIssuesEnum = [
            {
                id: '',
                label: 'LABEL_ALL'
            },
            {
                id: PaymentIssueEnum.AuthorizationFailed,
                label: 'LABEL_AUTHORIZATION_FAILED'
            },
            {
                id: PaymentIssueEnum.BalanceNotAvailable,
                label: 'LABEL_BALANCE_NOT_AVAILABLE'
            },
            {
                id: PaymentIssueEnum.Decline,
                label: 'LABEL_DECLINED'
            },
            {
                id: PaymentIssueEnum.Duplicate,
                label: 'MESSAGE_CC_STATUS_DUPLICATE'
            },
            {
                id: PaymentIssueEnum.ExpiredCard,
                label: 'LABEL_EXPIRED'
            },
            {
                id: PaymentIssueEnum.PickUpCard,
                label: 'LABEL_PICK_UP_CARD'
            }
        ];
        private _phoneTypeEnum = {
            [PhoneTypeEnum.Work]: 'LABEL_WORK',
            [PhoneTypeEnum.Mobile]: 'LABEL_MOBILE',
            [PhoneTypeEnum.Home]: 'LABEL_HOME'
        };

        get clientHasPhoneNumber() {
            return this.client && this.client.phoneNumbers instanceof Array && this.client.phoneNumbers.length > 0;
        }

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected $locale: angular.ILocaleService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected clientMembershipDataService: Meevo.Components.Common.ClientMembershipDataService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected eftControlPanelAPI: Meevo.Plugins.EftControlPanel.EFTControlPanelAPI,
            protected paymentPlansHelper: PaymentPlansHelper,
            private $mdSidenav: any
        ) {
            this.eftList = new Meevo.Components.BaseClasses.PagedResults(this.dataService, 'Membership/EFT', this.callbackOnPageLoadEft, this);
            this.ppList = new Meevo.Components.BaseClasses.PagedResults(this.dataService, 'PaymentPlan/EFT', this.callbackOnPageLoadPP.bind(this), this);


            let currDate = new Date();
            currDate.setMonth(currDate.getMonth() - 1);
            this.monthBeforeCurrentDate = new Date(new Date(currDate).setHours(0, 0, 0, 0));

            // Add new translate for efts status Pending
            this.eftStatusEnumForTable = angular.copy(this._eftStatusEnum);
            let eftPendingStatus: any = _.findWhere(this.eftStatusEnumForTable, { id: EFTStatusEnum.Pending });
            eftPendingStatus.label = 'LABEL_PENDING';

            this.eftStatusEnumForTable = _.map(this.eftStatusEnumForTable, (e: any) => {
                return (e.id === EFTStatusEnum.Pending) ? eftPendingStatus : e;
            });

            setTimeout(() => {
                this.showSidebar();
            }, 50);
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        /**
         * Filter List
         */
        criteriaChanged(): void {
            if (this.isDisabledSearch()) return;

            this.loadedItemsCount = 0;
            this.client = undefined;
            this.eftsSelected.count = 0;
            this.eftsSelected.totalCost = 0;
            this.selectAllEft = false;

            if (this.filterCriteria.criteria.isPaymentPlanEFT) {
                this.searchPP();
            } else {
                this.searchEFT();
            }

            let trackingItem = new TrackingItem(NounEnum.EftControlPanelPage, VerbEnum.SearchButtonClicked, this.filterCriteria.criteria, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

        searchPP() {
            const {
                isPaymentPlanEFT,
                EFTStatus,
                EFTPaymentIssue,
                EFTPaymentDateFrom,
                EFTPaymentDateTill,
            } = this.filterCriteria.criteria;
            this.ppList.initSearch({
                itemsPerPage: 25,
                criteria: {
                    isPaymentPlanEFT,
                    EFTPaymentIssue,
                    BillStatus: EFTStatus,
                    EFTPaymentDateFrom,
                    EFTPaymentDateTo: EFTPaymentDateTill,
                }
            });
            this.hideSidebar();
        }

        searchEFT() {
            this.eftList.initSearch(this.filterCriteria);
            this.dataService.customMethodData('api/Membership/EFT/List/Total', 'POST', this.filterCriteria.criteria).then((res: any) => {
                this.efts = {
                    count: res.data.totalQuantityForAll,
                    totalCost: res.data.totalAmountForAll
                }
                this.hideSidebar();
            });

        }

        isDisabledSearch() {
            if (!(typeof this.filterCriteria.criteria.EFTStatus === 'number')) {
                return true;
            }
            return false;
        }

        isPaymentPlanEFT() {
            if (this.filterCriteria.criteria.isPaymentPlanEFT) {
                return true;
            }
            return false;
        }

        showSidebar() {
            this.$mdSidenav('eftControlPanelSidenav').open();
            setTimeout(() => {
                this.$scope.$emit('eftControlPanelSidenav:isSideBarOpen', true);
            }, 0);
        }

        hideSidebar(){
            this.$scope.$emit('eftControlPanelSidenav:isSideBarOpen', false);
            this.$mdSidenav('eftControlPanelSidenav').close();
            this.selectedTotalCost = '0';
        }

        /**
         * Get translate for enum
         * */
        clientMembershipIndicatorEnumIcon(num): string {
            return this.clientMembershipDataService.getClientMembershipIndicatorEnumIcon(num);
        };

        clientMembershipIndicatorStatusText(num): string {
            return this.clientMembershipDataService.getClientMembershipIndicatorStatusEnumText(num);
        };

        callbackOnPageLoadEft(pageNumber, page, context) {
            _.forEach(page, (item: any) => {
                item.selected = context.selectAllEft && item.isReprocessable;
            });
            context.loadedItemsCount += page.length;

            context.checkIsDisabledEfts();
            this.hideSidebar();
        }

        callbackOnPageLoadPP(pageNumber, page: (IPaymentPlanEFTResponseItem & { statusVerbose: string; isDisabled: boolean; isReprocessable: boolean })[], context) {
            for (const pageElement of page) {
                pageElement.statusVerbose = this.paymentPlansHelper.payPlanPaymentStatusVerbose(pageElement.status);
                pageElement.isDisabled = this.filterCriteria.criteria.EFTStatus === EPaymentPlanBillStatusEnum.Paid ||
                    !pageElement.isReprocessable;
            }
            this.hideSidebar();
        }

        callbackSelectAllEft() {

            if (this.selectAllEft) {
                this.eftsSelected.count = this.efts.count;
                this.eftsSelected.totalCost = this.efts.totalCost;
            }

            for (let i = 0; this.loadedItemsCount > i; i++) {
                let item = <any>this.eftList.getItemAtIndex(i);
                if (item) {
                    if (item.isProcessing) {
                        item.selected = false;
                        this.eftsSelected.count -= item.quantity;
                        this.eftsSelected.totalCost -= item.totalAmount;
                    } else {
                        item.selected = this.selectAllEft && item.isReprocessable;
                    }

                }
            }

            if (!this.selectAllEft) {
                this.eftsSelected.count = 0;
                this.eftsSelected.totalCost = 0;
            }

            this.selectedTotalCost = this.eftsSelected.totalCost.toFixed(2);
        }

        eftStatusEnumTranslate(status) {
            let statusTitle: any = _.findWhere(this.eftStatusEnumForTable, { id: status });
            if (statusTitle) {
                return statusTitle.label;
            }
        }

        paymentMethodEnumTranslate(method) {
            let methodTitle = _.findWhere(this._paymentMethodEnum, { id: method });
            if (methodTitle) {
                return methodTitle.label;
            }
        }

        checkIsDisabledEfts(): void {
            let countDisabledEFTs = 0;

            for (let i = 0; this.loadedItemsCount > i; i++) {
                let item = <any>this.eftList.getItemAtIndex(i);
                if (item) {
                    item.isDisabled = this.isDisabledEFT(item);
                    if (item.isDisabled) {
                        countDisabledEFTs++;
                    }
                }
            }

            this.isDisabledSelectAll = countDisabledEFTs == this.loadedItemsCount && this.eftList.getLength() == this.loadedItemsCount ? true : this.isDisabledEFT();
        }

        isDisabledEFT(eft?) {
            if (this.filterCriteria.criteria.EFTStatus === EFTStatusEnum.Paid ||
                this.filterCriteria.criteria.EFTStatus === EFTStatusEnum.Waived ||
                this.filterCriteria.criteria.EFTStatus === EFTStatusEnum.Pending ||
                this.filterCriteria.criteria.EFTStatus === EFTStatusEnum.Processing ||
                (eft && (eft.isProcessing || !eft.isReprocessable))) {
                return true;
            }
            return false;
        }

        ppEFTStatusChanged() {
            this.showDatePicker = this.filterCriteria.criteria.EFTStatus === EPaymentPlanBillStatusEnum.Paid;
        }

        changeCriteriaEftStatus() {
            if (this.filterCriteria.criteria.EFTStatus === EFTStatusEnum.Pending) {
                this.filterCriteria.criteria.EFTPaymentMethod = PaymentMethodEnum.ACHChecking;
                this.isDisableEFTPaymentMethod = true;
            } else {
                this.filterCriteria.criteria.EFTPaymentMethod = null;
                this.isDisableEFTPaymentMethod = false;
            }

            // Datepicker shown
            switch (this.filterCriteria.criteria.EFTStatus) {
                case EFTStatusEnum.Paid:
                case EFTStatusEnum.Waived:
                case EFTStatusEnum.Pending:
                case EFTStatusEnum.FreezeFee:
                    this.showDatePicker = true;
                    this.filterCriteria.criteria.EFTPaymentDateFrom = this.currentDate;
                    this.filterCriteria.criteria.EFTPaymentDateTill = this.currentDate;
                    break;
                case EFTStatusEnum.Processing:
                case EFTStatusEnum.Error:
                case EFTStatusEnum.Suspended:
                case EFTStatusEnum.NotBilled:
                    this.showDatePicker = false;
                    this.filterCriteria.criteria.EFTPaymentDateFrom = null;
                    this.filterCriteria.criteria.EFTPaymentDateTill = null;
                    break;
                default:
                    this.showDatePicker = false;
                    this.filterCriteria.criteria.EFTPaymentDateFrom = this.currentDate;
                    this.filterCriteria.criteria.EFTPaymentDateTill = this.currentDate;
                    break;
            }
        }

        selectPaymentPlan(item: IPaymentPlanEFTResponseItem) {
            this.client = {
                name: `${item.firstName} ${item.lastName}`,
                id: item.clientId
            }
            this.paymentPlanSelectedEFTsTotal = this.ppList
                .getAllItems()
                .filter(item => item.selected && item.isReprocessable)
                .reduce((res, pp: IPaymentPlanEFTResponseItem) => {
                    res.count += pp.payments.length;
                    res.totalCost += pp.totalAmount;

                    return res;
                }, { count: 0, totalCost: 0 });
            this.selectedTotalCost = this.paymentPlanSelectedEFTsTotal.totalCost.toFixed(2);
            this.dataService.customMethodData('api/client/' + item.clientId, 'GET', null).then((res: any) => {
                this.client.phoneNumbers = res.data.phoneNumbers;
            });
        }

        selectEft(eft) {
            if (eft === this.selectedItem) {
                return
            }

            this.selectedItem = eft;

            this.client = {
                name: eft.clientName,
                id: eft.clientId
            };

            this.dataService.customMethodData('api/client/' + eft.clientId, 'GET', null).then((res: any) => {
                this.client.phoneNumbers = res.data.phoneNumbers;
            });
            this.dataService.customMethodData('api/Membership/Client/StatusIndicator/List', 'POST', { clientIds: [eft.clientId] }).then((res: any) => {
                this.client.clientMembershipIndicatorStatusEnum = res.data[0].clientMembershipIndicatorStatusEnum;
                this.client.clientMembershipIndicatorEnum = res.data[0].clientMembershipIndicatorEnum;
            });
            this.dataService.customMethodData('api/membership/client/' + eft.clientMembershipId, 'GET', null).then((res: any) => {
                // Example for credit card
                /*res.data.paymentAccounts.push({
                    paymentAccountType: 30053,
                    creditCardLastFour: '4568',
                    creditCardExpirationDate: '2017-09-14T00:00:00+03:00'
                });*/
                this.client.paymentAccounts = res.data.paymentAccounts;
            });
        }

        checkEft(eft) {
            if (eft.selected) {
                this.eftsSelected.count += eft.quantity;
                this.eftsSelected.totalCost = this.eftsSelected.totalCost + eft.totalAmount;
            } else {
                this.eftsSelected.count -= eft.quantity;
                this.eftsSelected.totalCost = this.eftsSelected.totalCost - eft.totalAmount;
            }
            this.selectAllEft = false;
            this.selectedTotalCost = this.eftsSelected.totalCost.toFixed(2);
        }

        checkIsReprocessable(eft) {
            if (!eft.isReprocessable) {
                this.modalService.alert("MESSAGE_EFT_CONTROL_PANEL_CANNOT_RESUBMIT", undefined, undefined, { modalClass: "modal-confirm" });
                return;
            }
        }

        // Request for process
        processPaymentPlan() {
            const {
                isPaymentPlanEFT,
                EFTStatus,
                EFTPaymentIssue,
                EFTPaymentDateFrom,
                EFTPaymentDateTill,
            } = this.filterCriteria.criteria;
            const processRequest = {
                isPaymentPlanEFT,
                EFTPaymentIssue,
                BillStatus: EFTStatus,
                EFTPaymentDateFrom,
                EFTPaymentDateTo: EFTPaymentDateTill,
                ProcessPayments: this.ppList
                    .getAllItems()
                    .filter(item => item.selected)
                    .map((item: any) => {
                        item.statusVerbose = 'LABEL_PROCESSING';
                        item.selected = false;

                        return {
                            PaymentPlanId: item.paymentPlanId,
                            BillStatus: EFTStatus
                        }
                    })
            }

            this.eftControlPanelAPI.processPaymentPlan(processRequest).then(() => {
                this.callbackSelectAllEft();
                this.checkIsDisabledEfts();
            });

            let trackingItem = new TrackingItem(NounEnum.EftControlPanelPage, VerbEnum.Sent, processRequest, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

        // Request for process
        processEfts() {
            let processRequest: any = angular.copy(this.filterCriteria.criteria);
            let ids = [];
            for (let i = 0; this.loadedItemsCount > i; i++) {
                let item = <any>this.eftList.getItemAtIndex(i);
                if (item.selected) {
                    ids.push(item.clientId);
                    item.isProcessing = true;
                    item.selected = false;
                }
            }

            processRequest.clientIds = this.selectAllEft ? [] : ids;

            this.dataService.customMethodData('api/Membership/EFT/Process', 'PATCH', processRequest).then((res: any) => {
                if (res.data.message) {
                    this.modalService.alert(res.data.message, undefined, undefined, { modalClass: "modal-confirm" });
                }
                this.selectAllEft = false;
                this.callbackSelectAllEft();
                this.checkIsDisabledEfts();
            });

            let trackingItem = new TrackingItem(NounEnum.EftControlPanelPage, VerbEnum.Sent, processRequest, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

        totalAmountMask(num) {
            return num.toString().includes('.') && num.toString().split('.').pop().length == 1 ? `${num}0` : num;
        }

        // Action for open client Profile
        showClientProfile($event: any, id: Guid): void {
            let stateParams = {
                id: id,
                actionState: Model.MaintenanceFormState.Readonly,
                targetState: Model.MaintenanceFormVisualState.Detail
            };

            this.$rootScope.$broadcast('gotoState', {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: stateParams
            });

            $event.stopPropagation();
        }
    }

    angular.module('meevo.plugins.eftControlPanel')
        .controller('meevo.plugins.eftControlPanel.EftControlPanelController', EftControlPanelController);
}
